import { Navigate, useLocation } from "react-router-dom";
// HOOK
import useAuth from "app/hooks/useAuth";

export default function AuthGuard({ children }) {
  const { isAuthenticated } = useAuth();
  const { pathname } = useLocation();
  const isEventsPage = pathname === "/events";
  const publicAccess = localStorage.getItem("isPublicAccess");

  if (isEventsPage && publicAccess === "true") {
    return <>{children}</>;
  }

  if (isAuthenticated) {
    return <>{children}</>;
  }

  return <Navigate replace to="/" state={{ from: pathname }} />;
}
